/**
 * Path constants for ShiftFeedback resolver
 */
export const SHIFT_FEEDBACK_RESOLVER_PATH = "shift-feedback-resolver";
